import { createStore } from 'vuex'

import auth from '../modules/auth/store'
import countries from '../modules/countries/store'
import states from '../modules/states/store'
import municipalities from '../modules/municipalities/store'
import dealers from '../modules/dealers/store'
import classifications from '../modules/classifications/store'
import vehicles from '../modules/vehicles/store'
import places from '../modules/places/store'
import typeproducts from '../modules/typeproducts/store'
import stafferstype from '../modules/stafferstype/store'
import companies from '../modules/companies/store'
import subsidiaries from '../modules/subsidiaries/store'
import racks from '../modules/racks/store'
import sites from '../modules/sites/store'
import clients from '../modules/clients/store'
import products from '../modules/products/store'
import inputsPending from '../modules/inputs/pending/store'
import inputdetails from '../modules/inputdetails/store'
import units from '../modules/units/store'
import inputsFinalized from '../modules/inputs/finalized/store'
import locations from '../modules/locations/store'
import inputsCancelled from '../modules/inputs/cancelled/store'
import outputsPending from '../modules/outputs/pending/store'
import outputdetails from '../modules/outputdetails/store'
import outputsFinalized from '../modules/outputs/finalized/store'
import outputsCancelled from '../modules/outputs/cancelled/store'
import productlot from '../modules/productlot/store'
import lots from '../modules/lots/store'
import generalInventory from '../modules/generalInventory/store'
import outputdetailsResume from '../modules/outputdetailsResume/store'
import roles from '../modules/roles/store'
import shared from '../shared/store'
import staffers from '../modules/staffers/store'
import users from '../modules/users/store'

const store = createStore({
    modules: {
        auth,
        countries,
        states,
        municipalities,
        dealers,
        classifications,
        vehicles,
        places,
        typeproducts,
        stafferstype,
        companies,
        subsidiaries,
        racks,
        sites,
        clients,
        products,
        inputsPending,
        inputdetails,
        units,
        inputsFinalized,
        locations,
        inputsCancelled,
        outputsPending,
        outputdetails,
        outputsFinalized,
        outputsCancelled,
        productlot,
        lots,
        generalInventory,
        outputdetailsResume,
        roles,
        shared,
        staffers,
        users
    }
})

export default store